
// Import modules...
import { createApp, h } from 'vue';

import ReservationCreate from '@/Components/Front/Reservations/ReservationCreate.vue'

import { translations } from '@/mixins/translations';
import { errors } from '@/mixins/errors';

const el = document.getElementById('reservation-app');

if (el) {

  const app = createApp({})

  // emulate Inertia global $page.props... for debug 
  // and assign  the global variable before mounting
  app.config.globalProperties.$page = {
    props: {
      debug: window?._$debug || null
    }
  }

  app.component('reservation-create', ReservationCreate)

  app.mixin(translations)
  app.mixin(errors)

  app.mount(el)
}